import { type FormEvent, useState } from 'react'
import { ErroRequisicao } from '../api/cliente'
import { useEntradaRapida, useEntrarRapido, useLogin } from '../api/hooks'
import { Marca } from '../componentes/Marca'
import { Aviso, Botao, Campo } from '../componentes/ui'
import { saiuPeloHorario as marcadoPeloHorario } from '../componentes/FimDoHorario'

export function Login({ saiuPeloHorario = false }: { saiuPeloHorario?: boolean }) {
  const [email, setEmail] = useState('')
  const [senha, setSenha] = useState('')
  const login = useLogin()
  // TEMPORÁRIO (ADR 0060): entrada rápida da apresentação, só neste computador.
  const { data: rapida } = useEntradaRapida()
  const entrarRapido = useEntrarRapido()
  // Lido uma vez ao abrir: o aviso fica até a próxima tentativa de entrar.
  const [pelaHora] = useState(() => marcadoPeloHorario() || saiuPeloHorario)

  const erro = login.error instanceof ErroRequisicao ? login.error : null

  function enviar(evento: FormEvent) {
    evento.preventDefault()
    login.mutate({ email, senha })
  }

  return (
    <div className="flex min-h-full items-center justify-center bg-tinta-100 p-4">
      <form
        onSubmit={enviar}
        className="w-full max-w-sm space-y-4 overflow-hidden rounded-xl ring-1 ring-tinta-200 bg-superficie p-6 shadow-media"
      >
        {/* A faixa da marca FaroEscolar (azul, turquesa e verde), como no topo dos cartões do site. */}
        <div aria-hidden className="-mx-6 -mt-6 mb-6 h-1.5 bg-linear-to-r from-marca via-faro-turquesa to-faro-verde" />
        {/*
          Cabeçalho centralizado, no mesmo eixo do aviso do rodapé.

          Estava encostado à esquerda enquanto o rodapé vinha centralizado: o
          cartão ficava com dois eixos, e o logo, que ocupa dois terços da
          largura, deixava um vão vazio só do lado direito. Os campos continuam
          alinhados à esquerda, porque rótulo em cima de campo se lê assim.
        */}
        <div className="text-center">
          {/*
            O logo continua dentro do `h1`: o nome da marca vira o texto do titulo, e a
            pagina nao fica sem cabecalho para leitor de tela nem para busca.
          */}
          <h1 className="flex justify-center">
            <Marca tamanho="g" />
          </h1>
          <p className="mt-2 text-sm text-tinta-400">Entre com seu e-mail e senha.</p>
        </div>

        {erro ? (
          <Aviso tipo={erro.status === 403 ? 'atencao' : 'erro'}>{erro.corpo.mensagem}</Aviso>
        ) : pelaHora ? (
          <Aviso tipo="atencao">
            Seu horário de trabalho terminou. Você pode entrar de novo no próximo horário.
          </Aviso>
        ) : null}

        <Campo
          rotulo="E-mail"
          type="email"
          autoComplete="username"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          erro={erro?.campo('email')}
          required
        />

        <Campo
          rotulo="Senha"
          type="password"
          autoComplete="current-password"
          value={senha}
          onChange={(e) => setSenha(e.target.value)}
          erro={erro?.campo('senha')}
          required
        />

        <Botao type="submit" variante="primario" className="w-full" carregando={login.isPending}>
          Entrar
        </Botao>

        {rapida && rapida.nomes.length > 0 ? (
          <div className="space-y-2 border-t border-tinta-100 pt-4">
            <p className="text-center text-xs font-semibold text-tinta-500">Entrar direto como</p>
            <div className="grid grid-cols-2 gap-2">
              {rapida.nomes.map((nome) => (
                <Botao
                  key={nome}
                  type="button"
                  carregando={entrarRapido.isPending && entrarRapido.variables === nome}
                  onClick={() => entrarRapido.mutate(nome)}
                >
                  {nome}
                </Botao>
              ))}
            </div>
            {entrarRapido.error ? <Aviso tipo="erro">{entrarRapido.error.message}</Aviso> : null}
          </div>
        ) : null}

        <p className="text-center text-xs text-tinta-400">
          Esqueceu a senha? Só o proprietário redefine, pela tela de configuração.
        </p>
      </form>
    </div>
  )
}
